import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, makeStyles, MenuItem, Typography } from '@material-ui/core';
import { transitionSpeed } from '../../../theme';
const useStyles = makeStyles((theme) => ({
    menuItem: {
        margin: 0,
        minHeight: 56,
        padding: 0,
        transition: `background-color ${transitionSpeed} ease-in`,
    },
    menuItemLink: {
        alignItems: 'center',
        display: 'flex',
        padding: theme.spacing(0.75, 1),
        width: '100%',
        '&:hover, &:focus': {
            textDecoration: 'none',
        },
    },
    svgContainer: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        marginRight: theme.spacing(2),
    },
    textContainer: {
        display: 'flex',
        flexDirection: 'column',
    },
}));
/**
 * Link for the `AppSwitcher` component
 *
 * @param {string} props.description - The description to be displayed under `props.text`.
 * @param {React.ReactElement} props.icon - The icon for the link.
 * @param {string} props.testId - The test id for the link.
 * @param {string} props.text - The text for the link.
 * @param {string} props.url - The path for the link.
 * @returns {JSX.Element} The rendered AppSwitcherLink component.
 */
export function AppSwitcherLink({ description, icon, testId, text, url }) {
    const classes = useStyles();
    return (_jsx(MenuItem, { className: classes.menuItem, divider: true, children: _jsxs(Link, { className: classes.menuItemLink, "data-testid": testId, href: url, target: '_blank', underline: 'none', children: [_jsx("div", { className: classes.svgContainer, children: icon }), _jsxs("div", { className: classes.textContainer, children: [_jsx(Typography, { variant: 'body1', color: 'textPrimary', children: text }), _jsx(Typography, { variant: 'body2', color: 'textSecondary', children: description })] })] }) }));
}
